import Header from '../../components/Header'
import MediaMatch from '../../components/MediaMatch'
import Footer from '../../components/Footer'

import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'
import Filter from '../../components/Filter'
import IconFilter from '../../assets/img/icon-filter.svg'
import {
  FilterMobileButton,
  FilterMobileWrapper
} from '../../components/Filter/styles'
import { useState, useEffect, useRef, useContext } from 'react'
import FilterMobile from '../../components/FilterMobile'
import EmptyBox from '../../components/EmptyBox'
import { useSelector, useDispatch } from 'react-redux'
import { setPage, setQuery } from '../../store/ducks/pagination'
import pedidos from '../../api/pedidos'
import * as S from '../../styles/page-profile'
import { ButtonExportar } from '../../styles/gimplus'
import PageSelector from '../../components/PageSelector'
import {
  CopyButton,
  CopyTooltip,
  FilterDesktopContainer,
  PromotorVendasHeader
} from '../../styles/vendasPromovidas'
import { fetchUser } from '../MeuPerfil/fetch'
import TableVendasPromovidas from '../../components/Table/TableVendasPromovidas'
import Loader from '../../components/Loader'
import { useToast } from '../../hooks/toast'
import { dateInFull } from '../../components/Filter/masks'
import { isPF } from '../../api/auth/auth'
import { useHistory } from 'react-router-dom'
import { CSVLink } from 'react-csv'
import csvDataBuilder from './csvData'
import { useLocation } from 'react-router-dom'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { UserContext } from '../../contexts/UserContext'
import { GetVendasPromovidasRequest } from '../../types/vendasPromovidas'
import { useQuery } from 'react-query'
import { getVendasPromovidasList } from '../../hooks/vendas/useVendasPromovidas'
import Paginator from '../../components/Paginator'

function VendasPromovidas() {
  // ==>  RHO97 <== CODIGO PROMOTOR MOCK
  const { user } = useContext(UserContext)

  const store = useSelector((reduxState) => reduxState)
  const dispatch = useDispatch()
  const codeRef = useRef()
  const { addToast }: any = useToast()
  const history = useHistory()

  // const [userData, setUserData] = useState({})
  const [showMenu, setShowMenu] = useState(false)
  const [csvData, setCsvData] = useState([])
  const [copy, setCopy] = useState(false)
  const [loader, setLoader] = useState(false)
  const [loaderContent, setLoaderContent] = useState(false)

  const [filterParams, setFilterParams] = useState<GetVendasPromovidasRequest>({
    CodigoPromotor: user.codigoPromotor,
    IdPedido: '',
    DataInicial: '',
    DataFinal: '',
    Page: 1,
    PageSize: 10
  })

  const { data, isLoading, isError, refetch } = useQuery(
    [
      'vendas-promovidas',
      user.codigoPromotor,
      filterParams.IdPedido,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getVendasPromovidasList(
        user.codigoPromotor,
        filterParams.IdPedido,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      // enabled: false,
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: `Verifique os campos e tente novamente`
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )

  const openMenu = () => {
    setShowMenu((prev) => !prev)
  }

  const fetch = async (
    codigoPromotor: string,
    idPedido: string,
    di: string,
    df: string,
    pg: number
  ) => {
    try {
      setFilterParams({
        CodigoPromotor: codigoPromotor,
        IdPedido: idPedido,
        DataInicial: di,
        DataFinal: df,
        Page: pg
      })

      console.log(filterParams)

      //Reseta o state com o pedidoId após primeiro fetch com o ID
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Não foi possível realizar busca',
        description: `Verifique os campos e tente novamente`
      })

      return err
    }
  }

  const copyToClipboard = () => {
    // codeRef.current.select()
    let hidden: any = document.getElementById('urlPromotor')
    hidden.style.display = 'block'
    hidden.select()
    hidden.setSelectionRange(0, 99999)

    document.execCommand('copy')
    hidden.style.display = 'none'

    setCopy(true)
    setTimeout(() => {
      setCopy(false)
    }, 800)
  }

  const location = useLocation()

  useEffect(() => {
    getLocalStorageLog(location.pathname)
    // getCodigoPromotor()

    !isPF() && history.push('/')
    // store.userinfo.codigoPromotor === undefined && history.push('/')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setCsvData(csvDataBuilder(data?.Data))
    // console.log(csvData)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.PageNumber])

  return (
    <S.Main>
      {!!isLoading && <Loader />}
      <FilterMobile
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        click={fetch}
        promotor={user.codigoPromotor}
        pedido
        opcoes={undefined}
        gimplus={undefined}
        small={undefined}
      />
      <Header></Header>
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Vendas Promovidas</BreadcrumbItem>
                </Breadcrumb>

                <MediaMatch greaterThan="1171px">
                  <ProfileTitle>Vendas Promovidas</ProfileTitle>
                </MediaMatch>

                <PromotorVendasHeader>
                  {user.dataCadastroPromotor !== null && (
                    <p>
                      <strong>Promotor desde: </strong>{' '}
                      {dateInFull(user.dataCadastroPromotor)}
                    </p>
                  )}
                  <p>
                    <strong>Código Promotor: </strong>
                    <CopyButton
                      value={user.codigoPromotor}
                      onClick={copyToClipboard}
                      ref={codeRef}
                      readOnly
                    />
                    <input
                      style={{ display: 'none' }}
                      id="urlPromotor"
                      type="text"
                      // value={`https://www.gimba.com.br/?promotorGimba=${user.codigoPromotor}`}
                      value={user.codigoPromotor}
                      ref={codeRef}
                    />
                    <CopyTooltip className="copy-message" active={copy}>
                      Código copiado!
                    </CopyTooltip>
                  </p>
                </PromotorVendasHeader>

                <MediaMatch greaterThan="large">
                  <FilterDesktopContainer className="vendas">
                    <Filter
                      pedido
                      click={fetch}
                      promotor={user.codigoPromotor}
                      opcoes={undefined}
                      small={undefined}
                      gimplus={undefined}
                      setShowMenu={undefined}
                      calendarModal={undefined}
                    />

                    {data?.Data.length > 0 ? (
                      <ButtonExportar>
                        <CSVLink
                          data={csvData}
                          filename={'vendas-promovidas.csv'}
                        >
                          Exportar
                        </CSVLink>
                      </ButtonExportar>
                    ) : (
                      <ButtonExportar>Exportar</ButtonExportar>
                    )}
                  </FilterDesktopContainer>
                </MediaMatch>

                <MediaMatch lessThan="large">
                  <FilterMobileWrapper>
                    <div>
                      <ProfileTitle>Vendas Promovidas</ProfileTitle>
                    </div>

                    <FilterMobileButton align={false} onClick={openMenu}>
                      <img src={IconFilter} alt="" />
                    </FilterMobileButton>
                  </FilterMobileWrapper>
                </MediaMatch>

                {!!isLoading ? (
                  <Loader />
                ) : (
                  <div className="content-vendas">
                    {data?.Data.length === 0 ? (
                      <EmptyBox>
                        Ainda não há pedidos para esse promotor.
                      </EmptyBox>
                    ) : (
                      <TableVendasPromovidas
                        data={data.Data}
                      ></TableVendasPromovidas>
                    )}
                    <Paginator
                      setFilterParams={setFilterParams}
                      data={data}
                    ></Paginator>
                    {/* <PageSelector click={fetch} /> */}
                  </div>
                )}
                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </S.Main>
  )
}

export default VendasPromovidas
